import { ReactElement, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { InfoView } from '@client/common/components/InfoView';
import { useLoginAction } from '@client/context/hooks';
import { useUserData } from '@client/context/hooks/useUserData';
import { useTranslate } from '@client/i18n/hooks';
import defaultImage from './assets/inactivity-min.svg';
import { Props } from './InactivityLogoutPage.types';

export const InactivityLogoutAlert = ({
  iconType,
  image = defaultImage,
  infoViewTestId,
}: Props): ReactElement => {
  const t = useTranslate();
  const redirectToLogin = useLoginAction();
  const userData = useUserData();
  const history = useHistory();

  useEffect(() => {
    if (userData.isLoggedIn) {
      history.push('/');
    }
  }, [userData.isLoggedIn, history]);

  const onLoginClick = (): void => {
    redirectToLogin();
  };

  const buttons = {
    primary: {
      content: t('Sign In'),
      onClick: onLoginClick,
    },
  };

  return (
    <InfoView
      image={image}
      title={t('You were signed out due to inactivity')}
      message={t('To continue where you left off, please sign in again.')}
      iconType={iconType}
      buttons={buttons}
      testId={infoViewTestId}
    />
  );
};
